import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '../../../Skeleton';
import { FolderSelectionList } from '../../FolderSelectionList';
import { SelectMenuTypes } from '../../helper';
import { MultiSelectionList } from '../../MultiSelectionList';
import { SingleSelectionList } from '../../SingleSelectionList';
import styles from '@dtsl/css-select-menu/dist/index.module.css';
import AlertTriangle from '@dtsl/icons/dist/icons/react/AlertTriangle';
function SelectMenuComponent(props) {
  const {
    selectMenuType,
    isLoading,
    options,
    noOptionContent,
    isCreateBtnPresent
  } = props;
  function getComponent() {
    switch (selectMenuType) {
      case SelectMenuTypes.SINGLE_SELECTION:
        return /*#__PURE__*/React.createElement(SingleSelectionList, props);
      case SelectMenuTypes.MULTI_SELECTION:
        return /*#__PURE__*/React.createElement(MultiSelectionList, props);
      case SelectMenuTypes.FOLDER_SINGLE_SELECTION:
        return /*#__PURE__*/React.createElement(FolderSelectionList, props);
      case SelectMenuTypes.FOLDER_MULTI_SELECTION:
        return /*#__PURE__*/React.createElement(FolderSelectionList, props);
      default:
        return null;
    }
  }
  return isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      rowGap: '0.5rem'
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "80%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "50%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "90%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "70%"
  }))) : options.length > 0 ? getComponent() : /*#__PURE__*/React.createElement("ul", {
    className: `${styles['sib-selectmenu-options']} ${options.length === 0 && isCreateBtnPresent ? styles['sib-selectmenu-options__no-padding'] : ''}`,
    role: "presentation"
  }, /*#__PURE__*/React.createElement("li", {
    className: `${styles['sib-selectmenu-option']} ${styles['sib-selectmenu-no_option']}`,
    role: "option",
    tabIndex: "0",
    "aria-selected": "false"
  }, noOptionContent));
}
SelectMenuComponent.defaultProps = {
  isCreateBtnPresent: false,
  isLoading: false,
  selectMenuType: 'singleSelection',
  options: [],
  noOptionContent: /*#__PURE__*/React.createElement("div", {
    className: styles['sib-selectmenu-no-option__content']
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 60,
    width: "50%"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['sib-selectmenu-no-option-wrapper']
  }, /*#__PURE__*/React.createElement("div", null, "Oops, there are no items in the list yet"), /*#__PURE__*/React.createElement("div", {
    className: styles['sib-selectmenu-no-option-subtext']
  }, /*#__PURE__*/React.createElement(AlertTriangle, null), " you should provide a solution.")))
};
SelectMenuComponent.propTypes = {
  isCreateBtnPresent: PropTypes.bool,
  isLoading: PropTypes.bool,
  selectMenuType: PropTypes.string,
  noOptionContent: PropTypes.node,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    value: PropTypes.any,
    icon: PropTypes.func,
    helpText: PropTypes.string,
    addtionalInfo: PropTypes.func
  }))
};
export default SelectMenuComponent;